export default {
    install: function (Vue, options) {
        Vue.prototype.$p = (message, placeholders) => {
            for (const p in placeholders) {
                const regex = new RegExp('\\{' + p + '\\}', 'g')
                message = (message || '').replace(regex, placeholders[p])
            }
            return message
        }
    }
}
